import React, { Fragment, ReactNode } from 'react';
import AssetThumbnailUI from './assetThumbnailUI';
import { UniqMotorcycle, UniqYacht, UniqWatch, Certifier } from '../api/dmdcuData';
import { DmdcuDataContext } from '../api/dmdcuDataContext';
import $ from 'jquery';

export interface IBrowserUIProps {
  dataContext: DmdcuDataContext;
}

enum BrowserUILoadingState {
  Unintialized,
  Loading, // it's about to load data from the blockchain
  Loaded, // the data is loaded, this state switch triggers the update of the UI.
  LoadFailed, // loading failed because of an error.
}

export class BrowserUIState {
  public loadingState: BrowserUILoadingState = BrowserUILoadingState.Unintialized;
  public motorcycles: UniqMotorcycle[] = [];
}

export class BrowserUI extends React.Component<IBrowserUIProps, BrowserUIState> {

  scriptsAreInitialized = false;

  public setLoadingState(state: BrowserUILoadingState) {
    this.setState((s, p) => ({
      loadingState: state,
    }));
  }

  componentDidUpdate() {

    if (this.state.loadingState !== BrowserUILoadingState.Loaded) {
      return;
    }

    if (this.scriptsAreInitialized) {
      return;
    }

    $('.certifiedItem.forSale figure a').append('<span class=\x27forSaleBadge\x27></span>');

    // Browser Custom Filters
    $('.myItemsFilter .showMyItems').click(function () {
      $(this).hide();
      $('.myItemsFilter .showAllItems').show();

      $('.certifiedItem').slideUp(500);
      $('.certifiedItem.owner').slideDown(500);
    });

    $('.myItemsFilter .showAllItems').click(function () {
      $(this).hide();
      $('.myItemsFilter .showMyItems').show();
      $('.certifiedItem').slideDown(500);
    });

    $('.forSaleItemsFilter .showForSale').click(function () {
      $(this).hide();
      $('.forSaleItemsFilter .showAllItems').show();

      $('.certifiedItem').slideUp(500);
      $('.certifiedItem.forSale').slideDown(500);
    });

    $('.forSaleItemsFilter .showAllItems').click(function () {
      $(this).hide();
      $('.forSaleItemsFilter .showForSale').show();
      $('.certifiedItem').slideDown(500);
    });

    $('.showMotorcyles').click(() => {
      $('.certifiedItem').fadeOut(500, () => {
        $('.certifiedItem.motorcycle').delay(100).fadeIn(500);
      });
    });

    $('.showYachts').click(() => {
      $('.certifiedItem').fadeOut(500, () => {
        $('.certifiedItem.yacht').delay(100).fadeIn(500);
      });
    });

    $('.showWatches').click(() => {
      $('.certifiedItem').fadeOut(500, () => {
        $('.certifiedItem.watch').delay(100).fadeIn(500);
      });
    });

    $('.filterCatgegories .showAllItems').click(() => {
      $('.certifiedItem').slideDown(500);
    });

    // tslint:disable-next-line
    $('.categoriesTrigger').click( function() {
      // console.log('clicked: ' + $(this).hasClass( "active" ));
      if (!$(this).hasClass('active')) {
        // console.log('activated - slide down');
        $(this).addClass('active');
        $('.filterCatgegories').slideDown(500);
      } else {
        // console.log('deactivated - slide up');
        $(this).removeClass('active');
        $('.filterCatgegories').slideUp(500);
      }
    });

    $('.viewOptions .showSimple').click(function () {
      $(this).fadeOut(250, () => {
        $('.viewOptions .showDetail').fadeIn(250);
      });
      $('.certifiedItem').addClass('simple-view');
    });

    $('.viewOptions .showDetail').click(function () {
      $(this).fadeOut(250,  () => {
        $('.viewOptions .showSimple').fadeIn(250);
      });
      $('.certifiedItem').removeClass('simple-view');
    });

    this.scriptsAreInitialized = true;
  }

  componentDidMount() {

    this.setLoadingState(BrowserUILoadingState.Loading);
    console.log('loading data from the blockchain');

    this.props.dataContext.getAllUniqueMotorcycles().then(
      (fulfilled) => {
        this.setState(() => ({
          motorcycles: fulfilled,
          loadingState: BrowserUILoadingState.Loaded,
        }));
      },
      (error) => {
        this.setLoadingState(BrowserUILoadingState.LoadFailed);
        console.log('Loading failed:', error);
      });
  }

  public render(): ReactNode {

    const myDataContext = this.props.dataContext;
    function motorcycleToUI(moto: UniqMotorcycle) : ReactNode {
      return <AssetThumbnailUI key={moto.id} motorcycle={moto} dataContext={myDataContext} />;
    }

    function yachtToUI(uniq: UniqYacht, isForSale: boolean = false) {

      return <div className={`certifiedItem yacht${isForSale ? ' forSale' : ''}`}>
                <h2><a href="#" title={`Show details of ${uniq.name}`}>{uniq.name}</a></h2>
                <p className="type">Yacht</p>
                <figure>
                  <a href="#" title={`Show details to ${uniq.name}`}>
                    <img src={`assets/${uniq.imageRessourcesIPFSAddress}`} alt={uniq.name} />
                  </a>
                </figure>
                <div className="infos">
                  <div className="compareable-data">
                    <div className="field">
                      <span className="label">Model Base Name</span>
                      <span className="value">{uniq.name2}</span>
                    </div>
                    <div className="field">
                      <span className="label">Custom. grade</span>
                      <span className="value">{uniq.customizationGradeAsText()}</span>
                    </div>
                    <div className="field">
                      <span className="label">Length:</span>
                      <span className="value">{`${uniq.length} m`}</span>
                    </div>
                    <div className="field">
                      <span className="label">Beam</span>
                      <span className="value">{`${uniq.beam} m`}</span>
                    </div>
                    <div className="field">
                      <span className="label">Top speed:</span>
                      <span className="value">{`${uniq.topSpeed} kn`}</span>
                    </div>
                    <div className="field">
                      <span className="label">Displacement</span>
                      <span className="value">{`${uniq.displacement} t`}</span>
                    </div>
                    <div className="field">
                      <span className="label">Build date</span>
                      <span className="value">{uniq.buildDateFormatted()}</span>
                    </div>
                    <div className="field">
                      <span className="label">Last modified</span>
                      <span className="value">{uniq.changeDateFormatted()}</span>
                    </div>
                    <div className="clear"></div>
                  </div>
                  <p className="shortdesc">uNiq Yacht demo asset</p>
                </div>
              </div>;
    }

    function watchToUI(uniq: UniqWatch, isForSale: boolean = false) {

      return <div className={`certifiedItem watch${isForSale ? ' forSale' : ''}`}>
                <h2><a href="#" title={`Show details of ${uniq.name}`}>{uniq.name}</a></h2>
                <p className="type">Watch</p>
                <figure>
                  <a href="#" title={`Show details to ${uniq.name}`}>
                    <img src={`assets/${uniq.imageRessourcesIPFSAddress}`} alt={uniq.name} />
                  </a>
                </figure>
                <div className="infos">
                  <div className="compareable-data">
                    <div className="field">
                      <span className="label">Model Base Name</span>
                      <span className="value">{uniq.name2}</span>
                    </div>
                    <div className="field">
                      <span className="label">Luxury grade</span>
                      <span className="value">{uniq.customizationGrade}</span>
                    </div>
                    <div className="field">
                      <span className="label">Edition Size</span>
                      <span className="value">{uniq.editionSize}</span>
                    </div>
                    <div className="field">
                      <span className="label">Edition Number</span>
                      <span className="value">{uniq.editionNumber}</span>
                    </div>
                    <div className="field">
                      <span className="label">Size</span>
                      <span className="value">{`${uniq.size} mm`}</span>
                    </div>
                    <div className="field">
                      <span className="label">Weight</span>
                      <span className="value">{`${uniq.weight} g`}</span>
                    </div>
                    <div className="field">
                      <span className="label">Build date</span>
                      <span className="value">{uniq.buildDateFormatted()}</span>
                    </div>
                    <div className="field">
                      <span className="label">Last modified</span>
                      <span className="value">{uniq.changeDateFormatted()}</span>
                    </div>
                    <div className="clear"></div>
                  </div>
                  <p className="shortdesc">uNiq Watch demo asset</p>
                </div>
              </div>;
    }

    console.log('render called!');
    if (this.state == null) {
      console.log('its to early to render.');
      return <div>No State available</div>;
    }

    if (this.state.loadingState === BrowserUILoadingState.Loading) {
      return <div>LOADING</div>;
    }

    if (this.state.loadingState === BrowserUILoadingState.Unintialized) {
      // should never occur, since componentdidMount triggers the loading state.
      return <div>UNINITIALIZED</div>;
    }

    if (this.state.loadingState === BrowserUILoadingState.LoadFailed) {
      return <div>LOADING FAILED</div>;
    }

    const firstThumbnail = this.state.motorcycles.length > 0 ? motorcycleToUI(this.state.motorcycles[0]) : undefined;
    const lastThumbnails = this.state.motorcycles.filter((x) => { return x.id !== 1; }).map((x) => { return motorcycleToUI(x); });
    const dummyCertifier = new Certifier('', '', '', '', '', '');

    return <Fragment>
      <section className="browser">
        <div className="sectionInner">
          <h1>Certified Items</h1>
          <div className="filter">
            <p className="filterTitle">Filter:</p>
            <p className="categoriesTrigger">
              Categories
                <span className="filterCatgegories">
                <span className="showAllItems">Show all items</span>
                <span className="showMotorcyles">Motorcycles</span>
                <span className="showYachts">Yachts</span>
                <span className="showWatches">Watches</span>
              </span>
            </p>
            <p className="viewOptions">
              Change view:
                <span className="showSimple">Simple</span>
              <span className="showDetail">Detail</span>
            </p>
            <div className="clear"></div>
            <p className="myItemsFilter">
              <span className="showMyItems">Show my items only</span>
              <span className="showAllItems">Show all items</span>
            </p>
            <p className="forSaleItemsFilter">
              <span className="showForSale">Show for Sale items</span>
              <span className="showAllItems">Show all items</span>
            </p>
            <div className="clear"></div>
          </div>
          <div className="clear"></div>
          <div className="certiefiedItems">
            {firstThumbnail}
            {yachtToUI(new UniqYacht(2, '', 'Gloria II', 'Sunseeker M. 56ft', '', 'sunseeker.jpg', dummyCertifier, 2, new Date(2003, 1), new Date(2017, 3), 1, 17, 6.3, 23, 25.5))}
            {yachtToUI(new UniqYacht(3, '', 'Slice of life', 'Bluewater 64ft', '', 'Bluewater.jpg', dummyCertifier, 2, new Date(2005, 3), new Date(2016, 6), 1, 19.5, 6.3, 24, 27.3))}
            {watchToUI(new UniqWatch(7, '', 'Masonic', 'Poljot - DeLuxe', '', 'Masonic.jpg', dummyCertifier, 3, new Date(2003, 3), new Date(2015, 3), 1, 1000, 113, 34, 68))}
            {yachtToUI(new UniqYacht(4, '', 'Seaturtle', 'Duretti 55ft', '', 'Duretti.jpg', dummyCertifier, 2, new Date(2007, 7), new Date(2016, 6), 1, 16.8, 4.9, 28,   24.2), true)}
            {watchToUI(new UniqWatch(8, '', 'Jetjulia', 'Rolex RX-13', '', 'watch-3.jpg', dummyCertifier, 3, new Date(2004, 5), new Date(2014, 3), 1, 3000, 143, 38, 72), true)}
            {yachtToUI(new UniqYacht(6, '', 'Ex Sibelle', 'G3', '', 'G3.jpg', dummyCertifier, 2, new Date(2012, 3), new Date(2013, 2), 1, 16.8, 4.9, 28,  25.3))}
            {watchToUI(new UniqWatch(9, '', 'Miracle', 'Swatch Tl D29', '', 'watch-1.jpg', dummyCertifier, 3, new Date(2003, 3), new Date(2015, 3), 1, 10000, 1563, 32, 82))}
            {yachtToUI(new UniqYacht(5, '', 'Aqua di Gola', 'Seaseeker V2', '', 'acquadigola.jpg', dummyCertifier, 2, new Date(2004, 3), new Date(2013, 2), 1, 16.8, 4.9, 28,  24.1))}
            {watchToUI(new UniqWatch(10, '', 'Stevenson', 'Jäger Carbon', '', 'watch-2.jpg', dummyCertifier, 3, new Date(2005, 7), new Date(2013, 3), 1, 6000, 1233, 37, 77))}
            {lastThumbnails}
          </div>
        </div>
      </section >
    </Fragment >;
  }
}

export default BrowserUI;
